module.exports = __webpack_public_path__ + "img/inspiration3.d1066e1e.png";